import React, { useState } from 'react';
import { Calendar, Search, Zap, Bug, Palette, Rocket } from 'lucide-react';
// Rendered from docs/release-notes/ by `npm run release:notes` - never edit by hand.
import entries from '../data/changelog.json';

const Changelog = () => {
  const [filter, setFilter] = useState('all');

  const typeConfig = {
    feature: { icon: Rocket, label: 'New Feature', color: '#2196F3', bg: '#e3f2fd' },
    fix: { icon: Bug, label: 'Bug Fix', color: '#4CAF50', bg: '#e8f5e8' },
    enhancement: { icon: Zap, label: 'Enhancement', color: '#9C27B0', bg: '#f3e5f5' },
    ui: { icon: Palette, label: 'UI/UX', color: '#FF9800', bg: '#fff3e0' }
  };

  const filteredEntries = filter === 'all'
    ? entries
    : entries.filter(entry => entry.type === filter);

  return (
    <section className="changelog">
      <div className="container">
        <div className="changelog-header">
          <div className="changelog-title">
            <Calendar className="changelog-icon" />
            <h1>What's New</h1>
          </div>
          <p className="changelog-subtitle">
            Stay up to date with the latest features and improvements in Snapcipe AI
          </p>
        </div>

        <div className="changelog-filters">
          <button
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Updates
          </button>
          {Object.entries(typeConfig).map(([type, config]) => (
            <button
              key={type}
              className={`filter-btn ${filter === type ? 'active' : ''}`}
              onClick={() => setFilter(type)}
            >
              <config.icon size={16} />
              {config.label}
            </button>
          ))}
        </div>

        <div className="changelog-timeline">
          {filteredEntries.map((entry) => {
            // An entry with an unknown type once blanked this whole page: the
            // renderer indexed the table with undefined and threw. Fall back.
            const config = typeConfig[entry.type] || typeConfig.enhancement;
            const TypeIcon = config.icon;
            return (
              <article key={entry.version} className="changelog-entry">
                <div className="entry-header">
                  <div className="entry-meta">
                    <div className="entry-badge">
                      <TypeIcon size={16} />
                      <span>{config.label}</span>
                    </div>
                    <time className="entry-date">{entry.date}</time>
                  </div>
                  <div className="entry-version">v{entry.version}</div>
                </div>

                <div className="entry-content">
                  <h2 className="entry-title">{entry.title}</h2>
                  <p className="entry-description">{entry.description}</p>

                  <ul className="changes-list">
                    {entry.changes.map((change, index) => (
                      <li key={index} className="change-item">
                        <span className="change-bullet">•</span>
                        <span>{change}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>

        <div className="changelog-footer">
          <div className="footer-cta">
            <h3>Want to be notified of updates?</h3>
            <p>Get the latest features delivered directly to your device through the App Store.</p>
            <div className="footer-actions">
              <a
                href="https://apps.apple.com/ch/app/snapcipe-ai/id6745421452?l=en-GB"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <Search size={18} />
                Download Latest Version
              </a>
              <a href="/#features" className="btn btn-secondary">
                Explore All Features
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Changelog;